import get from 'lodash/get';
import * as dealInfoHelpers from '../../utils/deal-info-helpers';


export function isSaleEnabled(video) {
  return Boolean(video && dealInfoHelpers.getSalePriceInfo(video.dealInfo));
}

export function isRentEnabled(video) {
  return Boolean(video && dealInfoHelpers.getRentPriceInfo(video.dealInfo));
}

export function isBought(video) {
  return Boolean(get(video, 'dgsInfo.sale'));
}

export function isRented(video) {
  return Boolean(get(video, 'dgsInfo.rent'));
}

export function isOwned(video) {
  return isRented(video) || isBought(video);
}

export function isFree(video) {
  return !isSaleEnabled(video) && !isRentEnabled(video);
}



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/ui-selectors/video/pricing.js